module.exports = __webpack_public_path__ + "static/media/all_caught.434b73bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/all_caught.svg
// module id = 1912
// module chunks = 0